type ProductId = string | number | null | undefined;

export function getProductManagerLink(productName: string, productId: ProductId, isEmployee: boolean) {
    if (!isEmployee || productId === null || productId === undefined || productId === '') return undefined;

    return `/manager/${productName}#id=${encodeURIComponent(productId)}`;
}
